'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditOutlined } from '@ant-design/icons';

import Button from 'components/buttons/Button';

import useWindowResponsiveness from 'hooks/common/useWindowResponsiveness';

import { IEditButtonProps } from './EditButton.types';

import './EditButton.styles.scss';

const EditButton = ({ label, icon, noIcon, block, ...props }: IEditButtonProps) => {
  const { t } = useTranslation();
  const { isMobileView } = useWindowResponsiveness(700);

  const buttonIcon = !noIcon ? icon || <EditOutlined /> : isMobileView ? icon || <EditOutlined /> : null;

  return (
    <Button
      size="middle"
      type="default"
      block={!isMobileView && block}
      shape={isMobileView ? 'circle' : 'round'}
      icon={buttonIcon}
      {...props}
    >
      {!isMobileView && t(label || 'form.button.edit')}
    </Button>
  );
};

export default EditButton;
